<template>
  <div>
    <apexchart
      type="line"
      height="450"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  name: "ViewedVsOrderedChart",
  props: {
    stats: Object
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 450,
          type: "bar",
          stacked: false,
          toolbar: { show: true },
          redrawOnParentResize: true,
          padding: { bottom: 20 },
          zoom: { enabled: true, type: "x", autoScaleYaxis: true }
        },
        colors: ["#1d3266", "#89c489", "#D4AF37"],
        stroke: {
          width: [2, 2, 2],
          curve: "smooth",
          colors: ['transparent', 'transparent', '#D4AF37']
        },
        plotOptions: { bar: { columnWidth: "50%", borderRadius: 2 } },
        dataLabels: { enabled: false },
        xaxis: { categories: [], labels: { rotate: -45, style: { fontSize: '11px' } } },
        yaxis: [
          { seriesName: "Consulté", axisTicks: { show: true }, axisBorder: { show: true, color: "#1d3266" }, labels: { style: { colors: "#1d3266" }, formatter: val => Math.round(val) }, title: { text: "Consultations", style: { color: "#1d3266" } } },
          { seriesName: "Commandé", opposite: true, axisTicks: { show: true }, axisBorder: { show: true, color: "#e2e8f0" }, labels: { style: { colors: "#e2e8f0" }, formatter: val => Math.round(val) }, title: { text: "Commandes", style: { color: "#e2e8f0" } } },
          { seriesName: "Conversion %", opposite: true, axisTicks: { show: true }, axisBorder: { show: true, color: "#D4AF37" }, labels: { style: { colors: "#D4AF37" }, formatter: val => Math.round(val) + "%" }, title: { text: "Taux de conversion (%)", style: { color: "#D4AF37" } } }
        ],
        tooltip: {
          shared: true,
          intersect: false,

          x: {
            formatter: (val, opts) => {
              const point = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
              return point.fullTitle || val;
            }
          },

          y: {
            formatter: val => Math.round(val)
          }
        },
        legend: { position: "top" },
        grid: { borderColor: "#e2e8f0", strokeDashArray: 2, padding: { left: 10, right: 10, bottom: 10 } },
        fill: { opacity: [0.9, 0.6, 1] },

        responsive: [
          {
            breakpoint: 768, // tablet & mobile
            options: {
              chart: { height: 350 },
              xaxis: { labels: { rotate: -60, style: { fontSize: "9px" } } },
              yaxis: [
                { show: false }, // hide yaxis on small screens
                { show: false },
                { show: false }
              ],
              legend: { position: "bottom", fontSize: "12px" }
            }
          }
        ]
      }
    };
  },
  watch: {
    stats: {
      immediate: true,
      handler(data) {
        if (!data) return;
        this.buildChart(data);
      }
    }
  },
  methods: {
    buildChart(data) {
      const names = data.label;
      const fullName = data.fullName;

      const mapDataWithTitles = (values) => {
        return values.map((val, index) => ({
          x: this.truncate(names[index]),
          y: val,
          fullTitle: fullName[index]
        }));
      };

      this.series = [
        { name: "Consulté", type: "column", data: mapDataWithTitles(data.consulted) },
        { name: "Commandé", type: "column", data: mapDataWithTitles(data.ordered) },
        { name: "Conversion %", type: "line", data: mapDataWithTitles(data.conversionRate) }
      ];

      this.chartOptions = {
        ...this.chartOptions,
        xaxis: { ...this.chartOptions.xaxis, categories: names.map(n => this.truncate(n)) }
      };
    },
    truncate(text) {
      return text && text.length > 10 ? text.substring(0, 10) + "..." : text;
    }
  }
};
</script>